import React, { Component } from "react";
import { Link } from "@sitecore-jss/sitecore-jss-react";
class UniversalBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBanner: true
    };
  }

  handleClick = () => {
    this.setState({
      showBanner: false
    });
  };

  render() {
    const {
      BannerLink,
      BannerBackgroundColor,
      BannerBackgroundImage,
      BannerFontColor,
      BannerIcon,
      BannerUseTimer,
      BannerCountdownDateTime,
      Timezone
    } = this.props.data;


    let countDownShow = false;
    let countDownDays, countDownHours, countDownMinutes;
    if (BannerUseTimer && BannerUseTimer.value && BannerCountdownDateTime && BannerCountdownDateTime.value) {

      let timezoneOffset = "+00:00";
      if (Timezone && Timezone.fields && Timezone.fields.Offset && Timezone.fields.Offset.value) {
        timezoneOffset = Timezone.fields.Offset.value;
      }

      // Parse timezone offset - handle both "+10:00" and "+10" formats
      let offsetHours, offsetMinutes;
      if (timezoneOffset.includes(':')) {
        // Format: "+10:00" or "-05:30"
        offsetHours = parseInt(timezoneOffset.split(':')[0]);
        offsetMinutes = parseInt(timezoneOffset.split(':')[1]) * Math.sign(offsetHours);
      } else {
        // Format: "+10" or "-5"
        offsetHours = parseInt(timezoneOffset);
        offsetMinutes = 0;
      }
      const timezoneOffsetMs = (offsetHours * 60 + offsetMinutes) * 60 * 1000;

      // Since the server datetime has 'Z' but is actually local time in the specified timezone,
      // we create the target date and apply the timezone offset directly
      const targetDate = new Date(BannerCountdownDateTime.value);
      const targetDateUTC = targetDate.getTime() - timezoneOffsetMs;

      // Calculate difference using UTC times
      const nowUTC = new Date().getTime();
      const timeDifference = targetDateUTC - nowUTC;

      countDownDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      countDownHours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countDownMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      countDownShow = timeDifference > 0;
    }

    let isDefault = true;
    if (
      (BannerBackgroundColor && BannerBackgroundColor.value) ||
      (BannerBackgroundImage && BannerBackgroundImage.value)
    ) {
      isDefault = false;
    }
    if (
      BannerLink &&
      BannerLink.value &&
      BannerLink.value.href &&
      BannerLink.value.text
    )
      return (
        <div
          className={
            "universal-banner " +
            (this.state.showBanner ? "" : "hidden ") +
            (this.props.isNavShown ? "is-hidden" : "") +
            (isDefault ? "" : " banner__themed")
          }
          style={{
            backgroundColor:
              BannerBackgroundColor && BannerBackgroundColor.value,
            backgroundImage:
              BannerBackgroundImage &&
                BannerBackgroundImage.value &&
                BannerBackgroundImage.value.src
                ? `url(${BannerBackgroundImage.value.src})`
                : null,
            color: BannerFontColor && BannerFontColor.value
          }}
        >
          <div className="container">
            <div className="universal-banner__details">
              {BannerIcon && BannerIcon.value ? (
                <i className={`icon banner-icon icon-${BannerIcon.value}`} />
              ) : (
                  ""
                )}
              <u>
                <Link field={BannerLink} />
              </u>
              {countDownShow && (
                <div className="universal-banner__countdown">
                  <div className="countdown-item">
                    <div className="countdown-value">{countDownDays}</div>
                    <div className="countdown-label">{countDownDays === 0 || countDownDays === 1 ? 'day' : 'days'}</div>
                  </div>
                  <div className="countdown-separator">:</div>
                  <div className="countdown-item">
                    <div className="countdown-value">{countDownHours}</div>
                    <div className="countdown-label">{countDownHours === 0 || countDownHours === 1 ? 'hour' : 'hours'}</div>
                  </div>
                  <div className="countdown-separator">:</div>
                  <div className="countdown-item">
                    <div className="countdown-value">{countDownMinutes}</div>
                    <div className="countdown-label">{countDownMinutes === 0 || countDownMinutes === 1 ? 'minute' : 'minutes'}</div>
                  </div>
                </div>
              )}
              <i
                className="icon banner-icon-close icon-outlined-x"
                onClick={this.handleClick}
              />
            </div>
          </div>
        </div>
      );
    else return null;
  }
}

export default UniversalBanner;
